import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";
import {handleError} from "../../../helpers/handleError";

const setCompanyExemption = {
    namespaced: true,
    state: {
        dataSaveIsFetching: false,
        textInfoInvoiceSave: "",
        typeInfoInvoiceSave: "",
        headInfoInvoiceSave: "",
        isLoading: false,
        isShowExemptionFormModal: false,
        isShowExemptionDeleteModal: false,
        exemptionToDelete: null,
        modalDataExemptionSet: {},
        isExemptionSet: false,
        exemptionsList: [],
    },
    mutations: {
        DATA_GET_SUCCESS(state, response) {
            state.exemptionsList = response.data.data
        },
        DATA_GET_FAILURE(state, error) {
            console.log(error.response.data.message);
        },
        DATA_SAVE_SUCCESS(state, response) {
            let dataReceive = {
                message: response.data.data.textInfo,
                title: response.data.message,
            }
            eventBus.$emit("setExemptionSuccess", dataReceive);
        },
        DATA_SAVE_FAILURE(state, error) {
            state.modalDataExemptionSet.textInfoExemptionSet = handleError(error) !== "" ? handleError(error) : error.response.data.data.message;
            state.modalDataExemptionSet.typeInfoExemptionSet = "red";
            state.modalDataExemptionSet.headInfoExemptionSet = error.response.data.message;
            state.isExemptionSet = true;

            eventBus.$emit("setExemptionFailure", error.response.data.errors);
        },
        DATA_DELETE_SUCCESS(state, response) {
            let dataReceive = {
                message: response.data.data.textInfo,
                title: response.data.message,
            }
            eventBus.$emit("deleteExemptionSuccess", dataReceive);
        },
        DATA_DELETE_FAILURE(state, error) {
            state.textInfoInvoiceSave = handleError(error) !== "" ? handleError(error) : error.response.data.data.message;
            state.typeInfoInvoiceSave = "red";
            state.headInfoInvoiceSave = error.response.data.message;

            eventBus.$emit("deleteExemptionFailure", error.response.data.errors);
        },
        UPDATE_VISIBLE_EXEMPTION_FORM(state, value) {
            state.isShowExemptionFormModal = value;
        },
        UPDATE_VISIBLE_EXEMPTION_DELETE(state, value) {
            state.isShowExemptionDeleteModal = value;
        },
        UPDATE_EXEMPTION_TO_DELETE(state, value) {
            state.exemptionToDelete = value;
        },
        UPDATE_VISIBLE_EXEMPTION_FAILURE_MODAL(state, value) {
            state.isExemptionSet = value;
        }
    },
    actions: {
        setExemption: function({ dispatch, state }, payload) {
            let promise = sendRequest("post", config.baseURLApi + "/user-company/exemption/store", {}, payload.creds);
            state.isLoading = true;
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successDataSave", result[1]);
                } else {
                    dispatch("failureDataSave", result[1]);
                }
                state.isLoading = false;
            });
        },
        deleteExemption: function({dispatch, state }) {
            let promise = sendRequest("delete", config.baseURLApi + "/user-company/exemption/delete/" + state.exemptionToDelete);
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successDataDelete", result[1]);
                } else {
                    dispatch("failureDataDelete", result[1]);
                }
            });
        },
        getExemptions({ dispatch }) {
            var promise = sendRequest("get", config.baseURLApi + "/user-company/exemptions", {});
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successGetExemptions", result[1]);
                } else {
                    dispatch("failureGetExemptions", result[1]);
                }
            });
        },
        successGetExemptions: function({ commit }, response) {
            commit("DATA_GET_SUCCESS", response);
        },
        failureGetExemptions: function({ commit }, response) {
            commit("DATA_GET_FAILURE", response);
        },
        successDataSave: function({ commit }, response) {
            commit("DATA_SAVE_SUCCESS", response);
        },
        failureDataSave: function({ commit }, error) {
            commit("DATA_SAVE_FAILURE", error);
        },
        successDataDelete: function({ commit }, response) {
            commit("DATA_DELETE_SUCCESS", response);
        },
        failureDataDelete: function({ commit }, error) {
            commit("DATA_DELETE_FAILURE", error);
        },
        updateVisibleExemptionFormModal({ commit }, value) {
            commit("UPDATE_VISIBLE_EXEMPTION_FORM", value)
        },
        updateVisibleExemptionDeleteModal({ commit }, value) {
            commit("UPDATE_VISIBLE_EXEMPTION_DELETE", value)
        },
        updateExemptionToDelete({commit}, id) {
            commit("UPDATE_EXEMPTION_TO_DELETE", id);
        },
        updateVisibleModalExemptionFailure({commit}, value) {
            commit('UPDATE_VISIBLE_EXEMPTION_FAILURE_MODAL', value);
        }
    }
}

export default setCompanyExemption;